import { MouseEvent } from 'react';
import cls from 'classnames';

import SvgIcon from '../../core/SvgIcon';
import { FormatIcon, FormatIconType, FormatIconSize } from '../../core/FormatIcon';

import useStyles from './styles';
import IFramedIconProps from './types';

export default function FramedIcon({
  className,
  outsideText,
  insidePrimaryText,
  insideSecondaryText,
  iconName,
  iconUrl,
  name,
  onClick,
  selected,
  horizontal,
}: IFramedIconProps) {
  const classes = useStyles();

  const click = (e: MouseEvent) => {
    onClick && onClick(e, name);
  };

  const containerClassName = cls(
    classes.root,
    selected && classes.selected,
    horizontal && 'horizontal',
    className,
  );

  if (iconName || iconUrl) {
    return (
      <div className={containerClassName} onClick={click}>
        <div className={cls(classes.container, classes.iconContainer)}>
          <SvgIcon name={iconName} url={iconUrl} />
        </div>
        <div className={cls(classes.outsideText, classes.outsideTextWithIcon)}>{outsideText}</div>
      </div>
    );
  }

  return (
    <div className={containerClassName} onClick={click}>
      <FormatIcon
        className="baseFormatIcon"
        format={selected ? FormatIconType.GENERIC_SELECTED : FormatIconType.GENERIC}
        size={horizontal ? FormatIconSize.SMALL : FormatIconSize.LARGE}
      >
        <div className={classes.container}>
          <div
            className={cls(classes.primaryText, horizontal && !insideSecondaryText && 'horizontal')}
          >
            {insidePrimaryText}
          </div>
          {insideSecondaryText && (
            <div className={classes.secondaryText}>{insideSecondaryText}</div>
          )}
        </div>
      </FormatIcon>
      <div className={classes.outsideText}>{outsideText}</div>
    </div>
  );
}
